export default {
  // Croatia hr(languagecode) HR(countrycode) Hrvatska / Hrvatski
  LandingPage: {
    intro_sub:
      'Udahnite ambalažnom otpadu nov život i uključite se u zaštitu okoliša.',
    title: 'Samsung Upcycle-Packagingg',
    sequence1_1: 'Pridružite nam se u smanjenju otpada',
    sequence1_2:
      'za održivi okoliš pretvaranjem pakiranja za proizvod u korisne predmete. Krećite se prema dolje kako biste napravili prvi korak.',
    sequence2_1: 'Predstavljamo Samsung Upcycle-Packaging',
    sequence2_2:
      'Kutija za proizvod posebno je dizajnirana kako bi se mogla upotrijebiti za doprinos okolišu. Napravite razne kućanske predmete uz pomoć svojeg pakiranja za proizvod.',
    sequence3_1: 'Slijedite otisnute točke na pakiranju',
    sequence3_2:
      'Izrežite pakiranje kako navode upute i složite ga kako biste stvorili nevjerojatan predmet.',
    sequence4_1: 'Odaberite predmet koji želite izraditi',
    sequence4_2:
      'Krećite se prema dolje i odaberite model proizvod koji imate na svojem pakiranju. Zatim pronađite razne mogućnosti dizajna. Krenite izrađivati željeni predmet.',
    selectBox: 'Odaberite svoj proizvod',
    moreActivity:
      "Za dodatne informacije o održivim aktivnostima tvrtke Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'Frame televizor', //update
    theSerif: 'Serif televizor', //update
    theSero: 'Sero televizor', //update
    theTerrace: 'Terrace televizor', //update
    thePremiere: 'Premiere projektor', //update
    Monitors: 'Monitori', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar zvučnik', //update
    Soundbar: 'Soundbar zvučnik', //update
    SoundbarSet01:'Soundbar zvučnik Set 1',
    SoundbarSet02:'Soundbar zvučnik Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/hr/sustainability/overview/',
    //moreActivityLink:'https://www.samsung.com/hr/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/hr/sustainability/overview/',
    footer: `
    Autorska prava© 2019 - 2021 Samsung. Sva prava pridržana`,
  },
  ProductPage: {
    selectDesign: 'Odaberite dizajn za izradu',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Konzola za televizor',
    StorageBox: 'Kutija za pohranu',
    MagazineRack: 'Stalak za časopise',
    CatHouse: 'Kućica za mačke',
    CatTunnel: 'Tunel za mačke',
    BookShelf: 'Polica za knjige',
    DeskShelf: 'Polica za radni stol',
    BlackRhino: 'Ugrožene životinje \n crni nosorog', //update
    PolarBear: 'Ugrožene životinje \n polarni medvjed', //update
    SeaTurtle: 'Ugrožene životinje \n morska kornjača', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex stolić \n uz kauč', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko stolić', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Stalak za \n razglednice', //update
    SneakerRack: 'Stalak za \n tenisice', //update
    TheSoban: 'Soban', //update
    ToolBox: 'Kutija za alat', //update
    DeskStationary: 'Stalak za pisaći pribor',
    CoinBank: 'Spremnik za kovanice',
    MobileScanner:'Stalak za skener pametnih telefona',
    TabletScanner:'Stalak za skener tableta',
    PetStairs:'Stepenice za kućne ljubimce',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'min',
    all:'ALL',
    in: 'in',
    inOnly: 'samo in',
    allBoxSize: 'Sve veličine kutija',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'upute',
    prepare: 'Pripremite kutiju',
    LetsDesign: "Dizajnirajmo",
    drawParts: 'Nacrtajte dijelove na kutiji',
    note1: 'Grafički položaj može se razlikovati ovisno o zemlji i veličini',
    note2: 'Prvo skicirajte cijeli crtež kako bi stao u kutiju',
    numberSpace: 'broj = mjesta između točaka',
    diagonal: 'dijagonalno',
    LEFT: 'LIJEVI (dio)',
    RIGHT: 'DESNI (dio)',
    TOP: 'GORNJI (dio)',
    TOP1: 'GORNJI (dio) 1',
    TOP2: 'GORNJI (dio) 2',
    BACK: 'STRAŽNJI (dio)',
    MIDDLE: 'SREDNJI (dio)',
    MIDDLE2: 'SREDNJI (dio) 2',
    BOTTOM: 'DONJI (dio)',
    FRONT: 'PREDNJI (dio)',
    SIDE: 'BOČNI (dio)',
    secondSIDE: 'DRUGA STRANA (dio)',
    secondSIDE1: 'DRUGA STRANA (dio) 1',
    secondSIDE2: 'DRUGA STRANA (dio) 2',
    LEG: 'NOGA (dio)', //update
    JOINT: 'SPOJ (dio)', //update
    FACE: 'PREDNJA STRANA (dio)', //update
    DRAWERBOTTOM: 'DNO LADICE (dio)', //update
    DRAWERSIDE: 'BOČNA STRANA LADICE (dio)', //update
    NOSE: 'NOS (dio)', //update
    HANDLE: 'RUČKA (dio)', //update
    BOTTOMSIDE: 'DONJA STRANA (dio', //update
    TOPSIDE: 'GORNJA STRANA (dio)', //update
    WING: 'KRILO (dio)', //update
    cutAndAssemble: "Razrežimo i složimo",
    beCareful: 'Pazite da se ne ozlijedite rezačem',
    cutOutParts: 'Izrežite dijelove',
    assemble: 'Sastavite',
    Assemblyguide: 'Vodič za sastavljanje', //update
    fold: 'Primjer presavijanja',
    foldGuide: 'Upotrijebite rub namještaja za presavijanje kartona',
    foldGuideDezeen:
      'Pritisnite istočkanu crtu na kartonu alatom za presavijanje nekoliko puta kako biste olakšali njegovo presavijanje', //update
    glue: 'Ravnomjerno nanesite ljepilo ili ljepljivu traku na površinu', //update
    cable: 'Upotrijebite vezice kabela ili žice za pričvršćivanje', //update
    done: 'Gotovo!',
    goBack: 'Povratak na glavni izbornik',
  },
  CautionPage: {
    CAUTION: 'OPREZ',
    needItem: 'Trebaju Vam sljedeći predmeti',
    children: 'Djeca moraju biti pod nadzorom odrasle osobe',
    mat:
      'Stavite zaštitu na pod kako biste ga zaštitili od ogrebotina tijekom izrade',
    doNotPutHeavyThing:
      'Nemojte stajati niti sjediti na ovom namještaju i nemojte na njega stavljati teške predmete',
    doNotThrow:
      'Nemojte udarati namještaj niti ga bacati prema osobama i životinjama',
    stayAwayFlame: 'Držite podalje od plamena',
    stayAwayWater: 'Ne upotrebljavajte u blizini vode ili vlage',
    mayDamaged: '* Kutija za televizor može se oštetiti u procesu slanja',
    companyDoestResponsible:
      '* Tvrtka nije odgovorna za kvarove ili ozljede tijekom izrade',
    cannotBeReturned:
      '* Proizvod s oštećenim kutijama ne može se vratiti zbog problema s kvalitetom',
    understand: 'U redu, shvaćam',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Ekološka stranica',
      text1:
        'U većini našeg pakiranja za televizore koristili smo manje papira i tinte u usporedbi s našim prijašnjim pakiranjem kako bismo pojačali svoju predanost održivosti',
      text2:'',
      text2_special:
        '(* Gore navedeno ne odnosi se na određene modele, uključujući Lifestyle televizore.)',
      text3: 'Odaberite donje gumbe da biste saznali više',
    },
    greenIn: {
      title: 'Ekološki aspekt pakiranja za televizore',
      subtitle1: 'Potražite informacije o proizvodu',
      subtitle2: 'Upotreba ekopakiranja',
      desc: 'Potražite naziv modela za dodatne informacije',
      descM: '* Slikajte broj modela televizora',
      guide: 'naziv modela',
      button: 'Slikajte',
      button2: 'Idite na izradu predmeta',
      product_info: 'Informacije o proizvodu',
    },
    search: {
      guide: 'Pretraži...',
      noResult: 'Nema rezultata',
      more: 'VIŠE',
      search: 'Pretraži',
      retake: 'Ponovno slikaj',
      result: 'Rezultat',
    },
    photo: {
      guide1: 'Mjesto u kutiji na kojem je naziv modela televizora',
      guide2: '(npr. Q800A, UT7000, RU7100 itd.)',
    },
  },
  searchCountrySelect: 'Odaberite zemlju za pretraživanje'
};
